<template>
   <HeaderBar></HeaderBar>
<main id="main_container">
    <MySitesBar></MySitesBar>
    <div class="sidebar">

        <div class="sidebarItme">
            <div v-for="outItem in toolDatas" v-bind:key="outItem.id" class="tagGroups">
                <div class="tagGroupTitle">{{outItem.nodeName}}</div>
                <div class="tagGroupItems">
                    <div v-for="item in outItem.items" v-bind:key="item.id" class="tool_tag_item">
                        <a :href="item.url" target="_blank" v-on:click="clickLink(item.id,1)">
                            <span>{{ item.name }}</span>
                        </a>
                    </div>
                </div>
            </div>
        </div>

        <div class="sidebarItme">
            <div v-for="outItem in tagDatas" v-bind:key="outItem.id" class="tagGroups">
                <div class="tagGroupTitle">{{outItem.name}}</div>
                <div class="tagGroupItems">
                    <div v-for="item in outItem.items" v-bind:key="item.id" class="tag_item">
                        <a v-on:click="toSiteMap(outItem.id,item.c_id,item.id,item.home_type)">{{ item.name }}</a>
                    </div>
                </div>
            </div>
        </div>
        
        <div v-for="outItem in otherDatas" v-bind:key="outItem.id" class="sidebarItme">
            <div class="sideTitle">{{outItem.nodeName}}</div>
            <div class="sideItems">
                <div v-for="item in outItem.items" v-bind:key="item.id" class="site_item">
                    <a :href="item.url" target="_blank" v-on:click="clickLink(item.id,1)">
                        <div>
                            <img :src="!item.icon?'':item.icon"/>
                        </div>
                        <span>{{ item.name }}</span>
                    </a>
                </div>
            </div>
        </div>

    </div>
    <section class="content">
        <div class="hotDataContainer">
            <div class="h_group">
                <div v-for="(outItem,index) in hotDatas" v-bind:key="outItem.id" :class="index==2?'h_group_item_last':'h_group_item'">
                    <div class="hot_item_title">
                        <img :src="outItem.icon"/>
                        <span class="hot_item_title_text">{{outItem.name}}</span> 
                        <a title="刷新" v-on:click="refreshHotDatas(index)">
                            <img style="height: 13px;width: 15px;padding-top: 4px;" src="../assets/refresh.png"/>
                        </a>
                        <a href="/hots" target="_blank">更多></a>
                    </div>
                    <div v-if="outItem.items.length>0" class="sideHotItems">
                        <div v-for="(item,index) in outItem.items" v-bind:key="item.id" class="hot_item">
                            <div :class="index>2?'num_fourth':'num_third'">{{ index+1 }}</div>
                            <a :href="item.url" target="_blank" v-on:click="clickLink(item.id,2)">
                                {{ item.title }}
                            </a>
                            <div class="hot_number" v-if="item.number>=100000">{{parseInt(item.number/10000)}}万</div>
                            <div class="hot_number" v-else-if="item.number<=0"></div>
                            <div class="hot_number" v-else>{{item.number}}</div>
                        </div>
                    </div>
                    <div v-else  class="sideHotItemsLoading">
                        数据加载中...
                    </div>
                </div>
            </div>
        </div>
        <div class="dataContainer">
            <div v-for="(t_item,index) in datas" v-bind:key="t_item.id" :class="index==0?'dataGroup_first':'dataGroup'" >
                <div v-if="index>=0 && index<=100" class="dataGroupTitle"><a v-on:click="toSiteMap(0,t_item.id,0,0)">{{ t_item.nodeName }}</a></div>
                <div v-if="index>=0 && index<=100" class="dataGroupItems">
                    <div v-for="s_item in t_item.items" v-bind:key="s_item.id" class="site_item">
                        <a draggable="true" @dragstart="dragStart" :id="s_item.id" :name="s_item.icon" :href="s_item.url" target="_blank" v-on:click="clickLink(s_item.id,1)">
                            <div>
                                <img :src="!s_item.icon?'':s_item.icon"/>
                            </div>
                            <span>{{ s_item.name }}</span>
                        </a>
                    </div>
                </div>
                <div v-if="index>=0 && index<=100" class="site_item_more"><a v-on:click="toSiteMap(0,t_item.id,0,0)">更多></a></div>
            </div>
        </div>
        <!-- 更多内容 -->
    </section>
</main>

<FooterBar></FooterBar>
        
</template>

<script>
/* eslint-disable no-unused-vars */
import http from '../http.js';
import FooterBar from '@/components/FooterBar.vue';
import HeaderBar from '@/components/HeaderBar.vue';
import MySitesBar from '@/components/MySitesBar.vue';
    export default {
        name: 'HomeIndex',
        components:{
            FooterBar,
            HeaderBar,
            MySitesBar
        },
        data(){
            return{
                datas:[],
                toolDatas:[],
                otherDatas:[],
                hotDatas:[],
                tagDatas:[],
            }
        },mounted () {
            this.getMainDatas(),
            this.getHotDatas(),
            this.getTagDatas()
        },
        methods:{
            dragStart(event){
                var target = event.target;
                console.log("event.target=",event.target)
                console.log("event.target.tagName=",event.target.tagName)
                if(event.target.tagName == "IMG"){
                    target = event.target.parentElement.parentElement;
                }
                if(target != undefined && target.tagName == "A"){
                    var url = target.href;
                    var name = target.text;
                    var id = target.id;
                    var icon = target.name;
                    const siteItem = { id:id, url:url,name:name,icon:icon };
                    event.dataTransfer.setData("text", JSON.stringify(siteItem));
                }
            },
            getMainDatas(){
                http.get('/getData')
                .then(response => {
                    this.datas=response.main_list;
                    this.toolDatas=response.tool_list;
                    this.otherDatas=response.other_list;
                })
                .catch(function (error) { // 请求失败处理
                    console.log(error);
                });
            },
            getTagDatas(){
                http.get('/getTagData')
                .then(response => {
                    this.tagDatas=response;
                })
                .catch(function (error) { // 请求失败处理
                    console.log(error);
                });
            },
            getHotDatas(){
                http.get('/getHotData')
                .then(response => {
                    this.hotDatas=response;
                })
                .catch(function (error) { // 请求失败处理
                    console.log(error);
                });
            },
            refreshHotDatas(index){
                this.hotDatas.forEach((item,h_index)=>{
                    if(index==h_index){
                        item.items=[];
                    }
                });
                http.get('/getHotData')
                .then(response => {
                    var datas = response;
                    var dataItems = []
                    if(datas != undefined && datas.length>0){
                        datas.forEach((item,h_index)=>{
                            if(index==h_index){
                                dataItems=item.items
                            }
                        });
                        this.hotDatas.forEach((h_item,h_index)=>{
                            if(index==h_index){
                                h_item.items=dataItems;
                            }
                        });
                    }
                })
                .catch(function (error) { // 请求失败处理
                    console.log(error);
                });
            },
            clickLink(id,type){
                http.post('/linkClick',{"id":id,"type":type})
                .then(response => {
                })
                .catch(function (error) { // 请求失败处理
                    console.log(error);
                });
            },
            toSiteMap(p_id,c_id,t_id,h_type){
                var q = p_id+"_"+c_id+"_"+t_id+"_"+h_type
                window.open(process.env.BASE_URL+"sitemap?q="+q, '_blank')
            }
        }
    }
</script>

<style scoped>
@import '../assets/styles.css';

</style>